/**
 * @generated SignedSource<<8b8f64b9acca8bcc3003c9ccc3a78f64>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from 'relay-runtime';
export type OrderDirection = 'ASC' | 'DESC' | '%future added value';
export type VacancyOrderField = 'CREATED_AT' | 'LAST_INVITED_AT' | 'STATUS' | '%future added value';
export type VacancyStatus = 'CLOSED' | 'OPEN' | '%future added value';
export type FilterModel = {
  field: string;
  values: ReadonlyArray<string>;
};
export type VacancyOrder = {
  direction: OrderDirection;
  field?: VacancyOrderField | null;
};
export type VacancyQueriesListOfVacanciesQuery$variables = {
  after?: any | null;
  filters?: ReadonlyArray<FilterModel | null> | null;
  first?: number | null;
  orderBy?: VacancyOrder | null;
  orgId?: string | null;
  skip: boolean;
};
export type VacancyQueriesListOfVacanciesQuery$data = {
  readonly vacancies?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly 'applications': ReadonlyArray<{
          readonly id: string;
          readonly owner: {
            readonly id: string;
          };
        }> | null;
        readonly 'createdAt': String;
        readonly 'duties': ReadonlyArray<{
          readonly name: string;
        }> | null;
        readonly 'id': string;
        readonly 'invites': ReadonlyArray<{
          readonly id: string;
          readonly owner: {
            readonly id: string;
          };
        }> | null;
        readonly 'status': VacancyStatus;
        readonly 'title': string;
        readonly ' $fragmentSpreads': FragmentRefs<'VacancyFragments'>;
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: any | null;
      readonly hasNextPage: boolean;
    };
    readonly totalCount: number;
  } | null;
};
export type VacancyQueriesListOfVacanciesQuery = {
  response: VacancyQueriesListOfVacanciesQuery$data;
  variables: VacancyQueriesListOfVacanciesQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'after',
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'filters',
    },
    v2 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'first',
    },
    v3 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'orderBy',
    },
    v4 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'orgId',
    },
    v5 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'skip',
    },
    v6 = {
      kind: 'Variable',
      name: 'filters',
      variableName: 'filters',
    },
    v7 = {
      kind: 'Variable',
      name: 'orderBy',
      variableName: 'orderBy',
    },
    v8 = {
      kind: 'Variable',
      name: 'orgId',
      variableName: 'orgId',
    },
    v9 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null,
    },
    v10 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'status',
      storageKey: null,
    },
    v11 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'title',
      storageKey: null,
    },
    v12 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'name',
      storageKey: null,
    },
    v13 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'createdAt',
      storageKey: null,
    },
    v14 = [
      v9 /*: any*/,
      {
        alias: null,
        args: null,
        concreteType: 'Profile',
        kind: 'LinkedField',
        name: 'owner',
        plural: false,
        selections: [v9 /*: any*/],
        storageKey: null,
      },
    ],
    v15 = {
      alias: null,
      args: null,
      concreteType: 'Invite',
      kind: 'LinkedField',
      name: 'invites',
      plural: true,
      selections: v14 /*: any*/,
      storageKey: null,
    },
    v16 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: '__typename',
      storageKey: null,
    },
    v17 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'cursor',
      storageKey: null,
    },
    v18 = {
      alias: null,
      args: null,
      concreteType: 'PageInfo',
      kind: 'LinkedField',
      name: 'pageInfo',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'hasNextPage',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'endCursor',
          storageKey: null,
        },
      ],
      storageKey: null,
    },
    v19 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'totalCount',
      storageKey: null,
    },
    v20 = [
      {
        kind: 'Variable',
        name: 'after',
        variableName: 'after',
      },
      v6 /*: any*/,
      {
        kind: 'Variable',
        name: 'first',
        variableName: 'first',
      },
      v7 /*: any*/,
      v8 /*: any*/,
    ],
    v21 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'alts',
      storageKey: null,
    },
    v22 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'perma',
      storageKey: null,
    },
    v23 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'firstName',
      storageKey: null,
    },
    v24 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'lastName',
      storageKey: null,
    },
    v25 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'avatarUrl',
      storageKey: null,
    },
    v26 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'description',
      storageKey: null,
    },
    v27 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'size',
      storageKey: null,
    },
    v28 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'websiteUrl',
      storageKey: null,
    },
    v29 = [v9 /*: any*/, v12 /*: any*/, v22 /*: any*/];
  return {
    fragment: {
      argumentDefinitions: [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/, v3 /*: any*/, v4 /*: any*/, v5 /*: any*/],
      kind: 'Fragment',
      metadata: null,
      name: 'VacancyQueriesListOfVacanciesQuery',
      selections: [
        {
          condition: 'skip',
          kind: 'Condition',
          passingValue: false,
          selections: [
            {
              alias: 'vacancies',
              args: [v6 /*: any*/, v7 /*: any*/, v8 /*: any*/],
              concreteType: 'VacancyConnection',
              kind: 'LinkedField',
              name: '__VacancyList_opened_vacancies_connection',
              plural: false,
              selections: [
                {
                  alias: null,
                  args: null,
                  concreteType: 'VacancyEdge',
                  kind: 'LinkedField',
                  name: 'edges',
                  plural: true,
                  selections: [
                    {
                      alias: null,
                      args: null,
                      concreteType: 'Vacancy',
                      kind: 'LinkedField',
                      name: 'node',
                      plural: false,
                      selections: [
                        v9 /*: any*/,
                        v10 /*: any*/,
                        v11 /*: any*/,
                        {
                          alias: null,
                          args: null,
                          concreteType: 'Duty',
                          kind: 'LinkedField',
                          name: 'duties',
                          plural: true,
                          selections: [v12 /*: any*/],
                          storageKey: null,
                        },
                        v13 /*: any*/,
                        v15 /*: any*/,
                        {
                          alias: null,
                          args: null,
                          concreteType: 'Application',
                          kind: 'LinkedField',
                          name: 'applications',
                          plural: true,
                          selections: v14 /*: any*/,
                          storageKey: null,
                        },
                        {
                          args: null,
                          kind: 'FragmentSpread',
                          name: 'VacancyFragments',
                        },
                        v16 /*: any*/,
                      ],
                      storageKey: null,
                    },
                    v17 /*: any*/,
                  ],
                  storageKey: null,
                },
                v18 /*: any*/,
                v19 /*: any*/,
              ],
              storageKey: null,
            },
          ],
        },
      ],
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [v4 /*: any*/, v0 /*: any*/, v2 /*: any*/, v5 /*: any*/, v1 /*: any*/, v3 /*: any*/],
      kind: 'Operation',
      name: 'VacancyQueriesListOfVacanciesQuery',
      selections: [
        {
          condition: 'skip',
          kind: 'Condition',
          passingValue: false,
          selections: [
            {
              alias: null,
              args: v20 /*: any*/,
              concreteType: 'VacancyConnection',
              kind: 'LinkedField',
              name: 'vacancies',
              plural: false,
              selections: [
                {
                  alias: null,
                  args: null,
                  concreteType: 'VacancyEdge',
                  kind: 'LinkedField',
                  name: 'edges',
                  plural: true,
                  selections: [
                    {
                      alias: null,
                      args: null,
                      concreteType: 'Vacancy',
                      kind: 'LinkedField',
                      name: 'node',
                      plural: false,
                      selections: [
                        v9 /*: any*/,
                        v10 /*: any*/,
                        v11 /*: any*/,
                        {
                          alias: null,
                          args: null,
                          concreteType: 'Duty',
                          kind: 'LinkedField',
                          name: 'duties',
                          plural: true,
                          selections: [v12 /*: any*/, v9 /*: any*/, v21 /*: any*/, v22 /*: any*/],
                          storageKey: null,
                        },
                        v13 /*: any*/,
                        v15 /*: any*/,
                        {
                          alias: null,
                          args: null,
                          concreteType: 'Application',
                          kind: 'LinkedField',
                          name: 'applications',
                          plural: true,
                          selections: [
                            v9 /*: any*/,
                            {
                              alias: null,
                              args: null,
                              concreteType: 'Profile',
                              kind: 'LinkedField',
                              name: 'owner',
                              plural: false,
                              selections: [
                                v9 /*: any*/,
                                {
                                  alias: null,
                                  args: null,
                                  concreteType: 'ProfileInfo',
                                  kind: 'LinkedField',
                                  name: 'info',
                                  plural: false,
                                  selections: [v23 /*: any*/, v24 /*: any*/, v25 /*: any*/, v9 /*: any*/],
                                  storageKey: null,
                                },
                              ],
                              storageKey: null,
                            },
                            v10 /*: any*/,
                          ],
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'industry',
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'salaryPeriod',
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          concreteType: 'Organization',
                          kind: 'LinkedField',
                          name: 'organization',
                          plural: false,
                          selections: [
                            v9 /*: any*/,
                            v26 /*: any*/,
                            v25 /*: any*/,
                            v27 /*: any*/,
                            {
                              alias: null,
                              args: null,
                              kind: 'ScalarField',
                              name: 'headquarters',
                              storageKey: null,
                            },
                            v28 /*: any*/,
                            v12 /*: any*/,
                          ],
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'salaryFrom',
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'salaryTo',
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'duration',
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'responsibilities',
                          storageKey: null,
                        },
                        v26 /*: any*/,
                        {
                          alias: null,
                          args: null,
                          concreteType: 'Certificate',
                          kind: 'LinkedField',
                          name: 'certificates',
                          plural: true,
                          selections: [
                            v9 /*: any*/,
                            v12 /*: any*/,
                            v21 /*: any*/,
                            {
                              alias: null,
                              args: null,
                              kind: 'ScalarField',
                              name: 'priority',
                              storageKey: null,
                            },
                            {
                              alias: null,
                              args: null,
                              kind: 'ScalarField',
                              name: 'neverExpires',
                              storageKey: null,
                            },
                            {
                              alias: null,
                              args: null,
                              concreteType: 'CertificateKind',
                              kind: 'LinkedField',
                              name: 'kind',
                              plural: false,
                              selections: v29 /*: any*/,
                              storageKey: null,
                            },
                          ],
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          concreteType: 'VesselKind',
                          kind: 'LinkedField',
                          name: 'vesselKind',
                          plural: false,
                          selections: v29 /*: any*/,
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          concreteType: 'HiringArea',
                          kind: 'LinkedField',
                          name: 'hiringArea',
                          plural: false,
                          selections: [v9 /*: any*/, v22 /*: any*/, v12 /*: any*/],
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'tornWeeksOff',
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'tornWeeksOn',
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          concreteType: 'Currency',
                          kind: 'LinkedField',
                          name: 'currency',
                          plural: false,
                          selections: v29 /*: any*/,
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'startingCondition',
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'startingDate',
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          concreteType: 'Contact',
                          kind: 'LinkedField',
                          name: 'contacts',
                          plural: true,
                          selections: v14 /*: any*/,
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          concreteType: 'OrganizationMember',
                          kind: 'LinkedField',
                          name: 'organizationMember',
                          plural: false,
                          selections: [
                            v9 /*: any*/,
                            {
                              alias: null,
                              args: null,
                              concreteType: 'Profile',
                              kind: 'LinkedField',
                              name: 'profile',
                              plural: false,
                              selections: [
                                v9 /*: any*/,
                                {
                                  alias: null,
                                  args: null,
                                  concreteType: 'ProfileInfo',
                                  kind: 'LinkedField',
                                  name: 'info',
                                  plural: false,
                                  selections: [v23 /*: any*/, v24 /*: any*/, v9 /*: any*/],
                                  storageKey: null,
                                },
                              ],
                              storageKey: null,
                            },
                            {
                              alias: null,
                              args: null,
                              concreteType: 'Organization',
                              kind: 'LinkedField',
                              name: 'organization',
                              plural: false,
                              selections: [v9 /*: any*/, v12 /*: any*/, v25 /*: any*/, v27 /*: any*/, v26 /*: any*/, v28 /*: any*/],
                              storageKey: null,
                            },
                          ],
                          storageKey: null,
                        },
                        v16 /*: any*/,
                      ],
                      storageKey: null,
                    },
                    v17 /*: any*/,
                  ],
                  storageKey: null,
                },
                v18 /*: any*/,
                v19 /*: any*/,
              ],
              storageKey: null,
            },
            {
              alias: null,
              args: v20 /*: any*/,
              filters: ['orgId', 'filters', 'orderBy'],
              handle: 'connection',
              key: 'VacancyList_opened_vacancies',
              kind: 'LinkedHandle',
              name: 'vacancies',
            },
          ],
        },
      ],
    },
    params: {
      cacheID: '05b160ae4bc6db909b37b0115e9ccc7d',
      id: null,
      metadata: {
        connection: [
          {
            count: 'first',
            cursor: 'after',
            direction: 'forward',
            path: ['vacancies'],
          },
        ],
      },
      name: 'VacancyQueriesListOfVacanciesQuery',
      operationKind: 'query',
      text: 'query VacancyQueriesListOfVacanciesQuery(\n  $orgId: ID\n  $after: Cursor\n  $first: Int\n  $skip: Boolean!\n  $filters: [FilterModel]\n  $orderBy: VacancyOrder\n) {\n  vacancies(orgId: $orgId, first: $first, after: $after, filters: $filters, orderBy: $orderBy) @skip(if: $skip) {\n    edges {\n      node {\n        id\n        status\n        title\n        duties {\n          name\n          id\n        }\n        createdAt\n        invites {\n          id\n          owner {\n            id\n          }\n        }\n        applications {\n          id\n          owner {\n            id\n          }\n        }\n        ...VacancyFragments\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalCount\n  }\n}\n\nfragment VacancyFragments on Vacancy {\n  id\n  createdAt\n  title\n  status\n  industry\n  salaryPeriod\n  organization {\n    id\n    description\n    avatarUrl\n    size\n    headquarters\n    websiteUrl\n    name\n  }\n  salaryFrom\n  salaryTo\n  duration\n  responsibilities\n  description\n  certificates {\n    id\n    name\n    alts\n    priority\n    neverExpires\n    kind {\n      id\n      name\n      perma\n    }\n  }\n  vesselKind {\n    id\n    name\n    perma\n  }\n  duties {\n    id\n    name\n    alts\n    perma\n  }\n  hiringArea {\n    id\n    perma\n    name\n  }\n  tornWeeksOff\n  tornWeeksOn\n  applications {\n    id\n    owner {\n      id\n      info {\n        firstName\n        lastName\n        avatarUrl\n        id\n      }\n    }\n    status\n  }\n  invites {\n    id\n    owner {\n      id\n    }\n  }\n  currency {\n    id\n    name\n    perma\n  }\n  startingCondition\n  startingDate\n  contacts {\n    id\n    owner {\n      id\n    }\n  }\n  organizationMember {\n    id\n    profile {\n      id\n      info {\n        firstName\n        lastName\n        id\n      }\n    }\n    organization {\n      id\n      name\n      avatarUrl\n      size\n      description\n      websiteUrl\n    }\n  }\n}\n',
    },
  };
})();

(node as any).hash = 'd7af36281fc8bc383ffd3c53acac5e96';

export default node;
